import { render, staticRenderFns } from "./AppUpdateNotice.vue?vue&type=template&id=ab704f64&scoped=true"
import script from "./AppUpdateNotice.vue?vue&type=script&lang=js"
export * from "./AppUpdateNotice.vue?vue&type=script&lang=js"
import style0 from "./AppUpdateNotice.vue?vue&type=style&index=0&id=ab704f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab704f64",
  null
  
)

export default component.exports